import React from "react";

import { cn } from "@/lib/utils";

const GLYPH_TRANSFORM = "translate(10 15) scale(0.805)";

const NINE_GLYPH_PATH =(
  "M51.1934 38.1074C54.6793 38.0634 58.1078 39.0349 61.0918 40.9131C63.1959 42.2375 65.0292 43.9669 66.499 46C66.4848 46.0302 66.4711 46.0606 66.457 46.0908C66.100" +
  "3 46.6884 65.8672 47.2351 65.6055 48.1816C65.5601 48.3691 65.5211 48.5693 65.4834 48.7793C65.0371 50.4472 64.8482 52.185 64.9297 53.9258C64.8253 57.022 65.4863 " +
  "60.0941 66.8486 62.8379C67.2634 63.5334 67.7216 64.1965 68.2178 64.8242C68.4246 65.0961 68.6424 65.362 68.873 65.6191C68.7604 65.9182 68.641 66.2155 68.5156 66." +
  "5098C67.0482 69.8286 65.2942 73.0014 63.2754 75.9893L48.6279 98.7422L47.8984 92.7549L47.1797 89.1885L57.3799 74.4346L57.2158 74.2646C55.0436 75.6967 52.5062 76." +
  "4109 49.9375 76.3125C46.9886 76.3108 44.0978 75.4574 41.5859 73.8477C38.7405 72.2709 36.3482 69.9343 34.6533 67.0781C32.9483 64.2046 32.0704 60.8819 32.124 57.5" +
  "039C32.1083 54.1608 32.9839 50.8784 34.6533 48.0234C36.3799 45.0675 38.7717 42.5941 41.6221 40.8184C44.5247 39.0449 47.8286 38.1093 51.1934 38.1074ZM51.2842 44." +
  "9326C49.1539 44.9234 47.0604 45.5135 45.2246 46.6396C43.3954 47.7037 41.8693 49.254 40.8027 51.1328C39.6858 53.0086 39.1168 55.1827 39.165 57.3896C39.1132 59.60" +
  "31 39.6824 61.7847 40.8027 63.666C41.8741 65.5409 43.399 67.0901 45.2246 68.1592C47.079 69.2615 49.1859 69.8182 51.3203 69.7705C53.4398 69.7879 55.5277 69.2329 " +
  "57.3799 68.1592C59.2161 67.0614 60.7606 65.504 61.874 63.6279C62.9544 61.7287 63.5204 59.5593 63.5117 57.3516C63.5179 55.1502 62.952 52.9879 61.874 51.0947C60.7" +
  "452 49.2383 59.1876 47.7065 57.3438 46.6396C55.4986 45.5368 53.4112 44.9484 51.2842 44.9326Z"
  );

const S_GLYPH_PATH =(
  "M72.9717 95.6973L68.8399 85.6687C70.3642 86.8948 70.7601 86.9415 73.3932 88.05C76.3529 89.1982 79.4811 89.7988 82.6379 89.8248C85.3204 90.0519 88.0119 89.5157 9" +
  "0.4277 88.2729C91.5788 87.5624 92.5297 86.5455 93.1837 85.3257C93.8377 84.1058 94.1715 82.7265 94.151 81.3282C94.1186 79.3694 93.4016 77.4913 92.1358 76.049C90." +
  "6203 74.1353 88.3468 73.3388 85.2015 71.9226L80.8592 69.9563C78.5224 68.9391 76.2775 67.7047 74.1514 66.2679C72.3126 64.996 70.7671 63.3121 69.6265 61.3379C68.5" +
  "042 58.9949 67.9848 56.3858 68.1196 53.7679C68.0571 51.6682 68.4616 49.5817 69.3014 47.6733C70.1411 45.7649 71.393 44.0867 72.9582 42.7712C76.5309 39.9532 80.05" +
  "88 38.9503 85.2922 38.8825C88.4184 38.8419 91.6609 39.2587 94.6906 40.0647L98.0663 49.484C96.535 48.657 95.4926 48.2384 94.1594 47.8042C91.383 46.9001 88.5161 4" +
  "6.3343 85.6156 46.1179C83.4927 45.8332 81.3361 46.1922 79.4017 47.1524C78.2778 47.7753 77.3288 48.6949 76.6489 49.82C75.9689 50.9451 75.5817 52.2366 75.5256 53." +
  "5664C75.4816 54.6844 75.6794 55.7984 76.1044 56.8249C76.5293 57.8515 77.1704 58.7642 77.9797 59.4948C78.6828 60.0584 79.4267 60.564 80.2047 61.0069C81.7308 61.8" +
  "967 83.3045 62.6941 84.918 63.3949L89.6359 65.5191C93.0581 66.9004 96.1954 68.9557 98.878 71.5739C100.021 72.8475 100.895 74.3588 101.443 76.0094C101.992 77.660" +
  "1 102.202 79.4132 102.061 81.1549C102.16 84.5105 101.197 87.8068 99.3218 90.5314C97.5876 92.978 95.1981 94.8302 92.4569 95.8526C89.3943 96.9695 86.1613 97.4846 " +
  "82.9205 97.3721C79.5418 97.349 76.1866 96.7842 72.9717 95.6973Z"
  );

function BrandGlyphs({ fill }: { fill: string }) {
  return (
    <g fill={fill} transform={GLYPH_TRANSFORM}>
      <path d={NINE_GLYPH_PATH} />
      <path d={S_GLYPH_PATH} />
    </g>
  );
}

type BrandMarkProps = {
  animated?: boolean;
  className?: string;
  compact?: boolean;
  testId?: string;
};

export function BrandMark({ animated = true, className, compact = false, testId = "brand-mark" }: BrandMarkProps) {
  const uid = React.useId().replace(/:/g, "");
  const [motionEnabled, setMotionEnabled] = React.useState(true);

  React.useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (media == null) return;
    const sync = () => {
      if (typeof media.matches !== "boolean") {
        setMotionEnabled(true);
        return;
      }
      setMotionEnabled(!media.matches);
    };
    sync();
    if (typeof media.addEventListener === "function") {
      media.addEventListener("change", sync);
      return () => media.removeEventListener("change", sync);
    }
    return undefined;
  }, []);

  const showMotion = animated && motionEnabled;
  const sweepDuration = compact ? "4.4s" : "3.2s";
  const strokeShineOpacity = compact ? 0.55 : 0.85;
  const fillShineOpacity = compact ? 0.62 : 0.92;

  const gold = `${uid}-gold`;
  const ring = `${uid}-ring`;
  const bg = `${uid}-bg`;
  const shine = `${uid}-shine`;
  const glow = `${uid}-glow`;
  const sweep = `${uid}-sweep`;
  const glyphMask = `${uid}-glyph-mask`;

  return (
    <svg
      aria-label="9S"
      className={cn("h-full w-full", className)}
      data-testid={testId}
      fill="none"
      role="img"
      viewBox="0 0 128 128"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={gold} gradientUnits="userSpaceOnUse" x1="24" x2="104" y1="104" y2="24">
          <stop stopColor="#FFC83C" />
          <stop offset="1" stopColor="#FFDD87" />
        </linearGradient>
        <linearGradient id={ring} gradientUnits="userSpaceOnUse" x1="18" x2="110" y1="110" y2="18">
          <stop stopColor="#9E8A56" />
          <stop offset="1" stopColor="#FFEAB4" />
        </linearGradient>
        <radialGradient id={bg} cx="0.34" cy="0.24" r="0.9">
          <stop stopColor="#8B6914" />
          <stop offset="0.42" stopColor="#5C4208" />
          <stop offset="1" stopColor="#1F1502" />
        </radialGradient>
        <linearGradient id={shine} gradientUnits="userSpaceOnUse" x1="64" x2="64" y1="6" y2="70">
          <stop stopColor="#FFDD87" stopOpacity="0.38" />
          <stop offset="1" stopColor="#FFDD87" stopOpacity="0" />
        </linearGradient>
        <linearGradient id={sweep} gradientUnits="userSpaceOnUse" x1="-48" x2="48" y1="0" y2="128">
          <stop offset="0%" stopColor="#FFF6E4" stopOpacity="0" />
          <stop offset="42%" stopColor="#FFDD87" stopOpacity="0" />
          <stop offset="50%" stopColor="#FFFFFF" stopOpacity="0.98" />
          <stop offset="58%" stopColor="#FFEB9E" stopOpacity="0.75" />
          <stop offset="100%" stopColor="#FFF6E4" stopOpacity="0" />
          {showMotion ? (
            <>
              <animate attributeName="x1" dur={sweepDuration} repeatCount="indefinite" values="-72;200;-72" />
              <animate attributeName="x2" dur={sweepDuration} repeatCount="indefinite" values="24;296;24" />
            </>
          ) : null}
        </linearGradient>
        <mask id={glyphMask}>
          <BrandGlyphs fill="white" />
        </mask>
        <filter height="160%" id={glow} width="160%" x="-30%" y="-30%">
          <feDropShadow
            dx="0"
            dy={compact ? 2 : 5}
            floodColor="#FFC83C"
            floodOpacity={compact ? 0.5 : 0.42}
            stdDeviation={compact ? 3.2 : 5}
          />
        </filter>
      </defs>

      <rect
        fill={`url(#${bg})`}
        filter={`url(#${glow})`}
        height="120"
        rx="28"
        width="120"
        x="4"
        y="4"
      />
      <rect fill={`url(#${shine})`} height="120" rx="28" width="120" x="4" y="4" />
      <rect
        fill="none"
        height="119"
        rx="27.5"
        stroke={`url(#${ring})`}
        strokeWidth="1.25"
        width="119"
        x="4.5"
        y="4.5"
      />

      <BrandGlyphs fill={`url(#${gold})`} />

      {showMotion ? (
        <>
          <rect
            fill={`url(#${sweep})`}
            height="128"
            mask={`url(#${glyphMask})`}
            opacity={fillShineOpacity}
            width="128"
            x="0"
            y="0"
          />
          <g
            fill="none"
            opacity={strokeShineOpacity}
            stroke={`url(#${sweep})`}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={compact ? 0.55 : 0.75}
            transform={GLYPH_TRANSFORM}
          >
            <path d={NINE_GLYPH_PATH} />
            <path d={S_GLYPH_PATH} />
          </g>
        </>
      ) : null}
    </svg>
  );
}
